/** @file currentClip: the clip on the playhead (name and document), or null. */
import type { Clip } from '@zilo/pose3d-format/types/clip';
import type { EditorState } from '../../state/editorTypes';

/** The playhead clip when the open document has it. */
export function currentClip(state: Pick<EditorState, 'playhead' | 'puppet'>): { name: string; clip: Clip } | null {
  const name = state.playhead.clip;
  const clip = name === null ? undefined : state.puppet.doc?.clips[name];
  return name === null || clip === undefined ? null : { name, clip };
}
